import React from 'react';
import { Box } from '@mui/material';

import { Card, Tab, Tabs } from '@occc/ui-design-system';

import { SurveyTabs } from '../constants';

type TabItem = {
  label: string;
  value: SurveyTabs;
};

export type ConfigurationLayoutProps = {
  children?: React.ReactNode;
  selectedTab: SurveyTabs;
  onTabSelected: (value: SurveyTabs) => void;
};

export const ConfigurationLayout = ({
  children,
  selectedTab,
  onTabSelected,
}: ConfigurationLayoutProps) => {
  const items: TabItem[] = [
    {
      value: SurveyTabs.Configure,
      label: 'Configure',
    },
    {
      value: SurveyTabs.Target,
      label: 'Target',
    },
    {
      value: SurveyTabs.Schedule,
      label: 'Schedule & Finalize',
    },
  ];

  return (
    <>
      <Box ml={2}>
        <Tabs
          indicatorColor='secondary'
          textColor='secondary'
          value={selectedTab}
          onChange={(e, value) => onTabSelected(value)}
        >
          {items.map((item) => (
            <Tab key={item.value} value={item.value} label={item.label} />
          ))}
        </Tabs>
      </Box>
      <Card>{children}</Card>
    </>
  );
};
